import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { AuthService } from './auth.service';
import Swal from 'sweetalert2';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { PreviousRouterService } from '../previous-route/previous-router.service';
import {KeycloakEventType, KeycloakService} from 'keycloak-angular'
import { keyService } from '../keycloak/service/key.service';
import { from } from 'rxjs';
import { filter } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export class AuthErrorInterceptor implements HttpInterceptor {
    currentURL: any;
    Url: any;
    isloggedin:any =false;
   constructor(private router: Router, private authService: AuthService, private urlService: PreviousRouterService, private kc:keyService, private key:KeycloakService) {
        router.events.subscribe(url => {
            this.currentURL = url
            if (this.currentURL.url) {
                this.Url = this.currentURL.url;
            }
        });
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(catchError(err => {
          setTimeout( async ()=>{
            this.isloggedin =await this.kc.isLoggedIn(); 
            if(this.isloggedin && err.status == 500){
                Swal.fire(
                    'OPPS',
                    'Internal server error',
                    'error'
                )
                // this.kc.logout()
            } else{
                if (err.status == 500) {
                    Swal.fire(
                        'OPPS',
                        'Internal server error',
                        'error'
                    )
                }
            }    
       },0.5) 
   
            if (err.status === 401) {
                //showing session timed out popup if 401 response returned from api
                if (this.Url !== '/login' && this.Url !== '' && this.Url == undefined && this.Url !== '/') {
                    this.authService.clearToken();
                    this.urlService.clearUrl();
                    sessionStorage.removeItem('confirmApp');
                    sessionStorage.removeItem("temp");
                    Swal.fire(
                        
                        'Your session has been timed out. Please login again.',
                        'Info'
                    )
                    this.router.navigate(['login']);

                } else {
                    sessionStorage.removeItem('confirmApp');
                    sessionStorage.removeItem("temp")
                    this.authService.clearToken();
                    Swal.fire(
                        
                        'Your session has been timed out. Please login again.',
                        'Info'
                    )
                    this.urlService.clearUrl();
                }
                // this.authenticationService.logout();
                sessionStorage.removeItem('userInfo');
            }
            return throwError(err);
        }))
    }


}